import React, { ChangeEvent, forwardRef } from 'react';
import { Grid, GridProps, TextField, TextFieldProps } from '@material-ui/core';
import StateSelectField, { StateSelectFieldProps } from '../StateSelectField';
import { useTranslation } from '@fluentsms/i18n';

export type LicenseFieldGroupProps = {
  ContainerComponentProps?: GridProps;
  StateSelectFieldProps?: StateSelectFieldProps;
  LicenseFieldProps?: TextFieldProps;
  value?: LicenseFields;
  onChange?: (value: LicenseFields) => void;
  onBlur?: () => void;
};

export type LicenseFields = {
  licensedState?: string | undefined;
  licenseNumber?: string | undefined;
};

export const LicenseFieldGroup = forwardRef<HTMLDivElement, LicenseFieldGroupProps>(
  (
    {
      ContainerComponentProps,
      StateSelectFieldProps,
      LicenseFieldProps,
      value: valueProp = { licensedState: '', licenseNumber: '' },
      onChange = () => undefined,
      onBlur = () => undefined,
    }: LicenseFieldGroupProps,
    ref,
  ) => {
    const { t } = useTranslation('common');

    const handleChange = (event: string | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (typeof event === 'string') {
        onChange({ ...valueProp, licensedState: event });
      } else {
        onChange({ ...valueProp, licenseNumber: event?.currentTarget?.value });
      }
    };
    return (
      <Grid ref={ref} item container {...ContainerComponentProps}>
        <Grid item xs={4}>
          <StateSelectField
            label={t('licenseFieldGroup.stateLabel')}
            data-testid="license-group-state-select"
            fullWidth
            onChange={handleChange}
            onBlur={onBlur}
            name="licensedState"
            id="state"
            value={valueProp?.licensedState ?? ''}
            {...StateSelectFieldProps}
          />
        </Grid>
        <Grid item xs={8}>
          <TextField
            label={t('licenseFieldGroup.licenseLabel')}
            data-testid="license-group-license-textfield"
            fullWidth
            onChange={handleChange}
            onBlur={onBlur}
            name="licenseNumber"
            id="license"
            value={valueProp?.licenseNumber ?? ''}
            {...LicenseFieldProps}
          />
        </Grid>
      </Grid>
    );
  },
);

LicenseFieldGroup.displayName = 'LicenseFieldGroup';

export default LicenseFieldGroup;
